import { Modal, BlockStack, Text, List } from '@shopify/polaris';

const ErrorModal = ({ active, onClose, errors = [] }) => {
    return (
        <Modal
            open={active}
            onClose={onClose}
            title="Cycle Count Errors"
            primaryAction={{
                content: 'Close',
                onAction: onClose,
            }}
        >
            <Modal.Section>
                <BlockStack gap="400">
                    {errors.length === 0 ? (
                        <Text>No errors to display</Text>
                    ) : (
                        <BlockStack gap="300">
                            <Text variant="bodyMd" tone="critical">
                                The following errors occurred while preparing the cycle count:
                            </Text>
                            <List type="bullet">
                                {errors.map((error, index) => (
                                    <List.Item key={error.id || index}>
                                        <BlockStack gap="100">
                                            <Text fontWeight="semibold">{error.message}</Text>
                                            {error.details && typeof error.details === 'string' && (
                                                <Text variant="bodySm" tone="subdued">
                                                    {error.details}
                                                </Text>
                                            )}
                                            {error.details && typeof error.details === 'object' && (
                                                <Text variant="bodySm" tone="subdued">
                                                    {JSON.stringify(error.details)}
                                                </Text>
                                            )}
                                        </BlockStack>
                                    </List.Item>
                                ))}
                            </List>
                        </BlockStack>
                    )}
                </BlockStack>
            </Modal.Section>
        </Modal>
    );
};

export default ErrorModal;
